import {
  MAX_ASSET_VERSIONS,
  MAX_SESSION_INTERACTIONS,
} from "@hightouch/core/ad-studio/constants";
import { AUDIO_FILE_EXTENSIONS } from "@hightouch/lib/ad-studio/media-upload";

export const isVideoAsset = (assetUrl?: string | null): boolean => {
  if (!assetUrl) return false;
  return /\.(mp4|mov|webm|m4v)($|\?)/i.test(assetUrl);
};

export const isAudioAsset = (assetUrl?: string | null): boolean => {
  if (!assetUrl) return false;
  const path = (assetUrl.split("?")[0] ?? "").toLowerCase();
  return AUDIO_FILE_EXTENSIONS.some((extension) => path.endsWith(extension));
};

export const ASSET_EDIT_LIMIT_MESSAGE =
  "Contact sales to continue editing this ad.";

export function getAgentVersionCount(
  versions?: Array<{ created_by_interaction_id?: string | null }> | null,
): number {
  if (!versions) return 0;
  return versions.filter((v) => v.created_by_interaction_id != null).length;
}

export function isAssetEditLimitReached(
  isSelfServe: boolean,
  agentVersionCount: number,
  interactionCount: number,
): boolean {
  return (
    isSelfServe &&
    (agentVersionCount >= MAX_ASSET_VERSIONS ||
      interactionCount >= MAX_SESSION_INTERACTIONS)
  );
}

export function isInteractionLimited(
  isSelfServe: boolean,
  interactionCount: number,
): boolean {
  return isSelfServe && interactionCount >= MAX_SESSION_INTERACTIONS;
}
